export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_kays-junk-removal/artifacts/gxgf72se_Kays%20Waste%20Management%20.png";

// WhatsApp business number — update this once activated.
// Format: international, digits only, no leading '+' or spaces.
// Example UK mobile 07700 900000 => "447700900000".
export const WHATSAPP_NUMBER = "447821357946";

export const IMAGES = {
  heroPrimary: "https://images.pexels.com/photos/29768245/pexels-photo-29768245.jpeg",
  serviceDomestic: "https://images.unsplash.com/photo-1595751100377-9954f1f99bad",
  serviceTrades: "https://images.pexels.com/photos/17976203/pexels-photo-17976203.jpeg",
  wasteBoxes: "https://images.unsplash.com/photo-1730154838368-c37b1fdebcf6",
};

export const AREAS = [
  "Weston-super-Mare",
  "Somerset",
  "Bristol",
  "Taunton",
  "Clevedon",
  "Portishead",
  "Nailsea",
  "Cheddar",
  "Burnham-on-Sea",
  "Bridgwater",
  "Yatton",
  "Wells",
];
